export const fieldContainer = "w-full";

export const fieldLabel =
  "mb-1.5 block text-[11px] font-semibold uppercase tracking-wide text-slate-600";

export const fieldControlBase =
  "w-full rounded-xl border border-slate-300 bg-white px-3 py-2.5 text-sm text-slate-800 shadow-sm transition duration-200 placeholder:text-slate-400 focus:border-emerald-500 focus:outline-none focus:ring-4 focus:ring-emerald-100 disabled:cursor-not-allowed disabled:bg-slate-100 disabled:text-slate-400";

export const fieldControlError =
  "border-red-400 focus:border-red-500 focus:ring-red-100";

export const fieldErrorText = "mt-1 block text-xs font-medium text-red-500";

export const fieldHelperText = "mt-1 block text-xs text-slate-500";
